import React, { useState, useEffect } from "react";
import moment from "moment";
import "./CountdownTimer.css"; // Import separate CSS

export const CountdownTimer = ({ deadline }) => {
  // Default deadline: March 27, 2025, at 4:00 PM
  const defaultDeadline = moment("2025-03-27 16:00:00", "YYYY-MM-DD HH:mm:ss");
  const finalDeadline = deadline ? moment(deadline) : defaultDeadline;

  const calculateTimeLeft = () => {
    const now = moment();
    const difference = moment.duration(finalDeadline.diff(now));

    if (difference.asMilliseconds() > 0) {
      return {
        days: String(Math.floor(difference.asDays())).padStart(2, "0"), // Total days
        hours: String(difference.hours()).padStart(2, "0"),
        minutes: String(difference.minutes()).padStart(2, "0"),
        seconds: String(difference.seconds()).padStart(2, "0"),
      };
    } else {
      return { days: "00", hours: "00", minutes: "00", seconds: "00" };
    }
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, [finalDeadline]);

  return (
    <div className="countdown-container">
      <div className="time-box">
        <span>{timeLeft.days}</span>
        <small>Days</small>
      </div><span className='colen'>:</span>
      <div className="time-box">
        <span>{timeLeft.hours}</span>
        <small>Hours</small>
      </div><span className='colen'>:</span>
      <div className="time-box">
        <span>{timeLeft.minutes}</span>
        <small>Minutes</small>
      </div><span className='colen'>:</span>
      <div className="time-box">
        <span>{timeLeft.seconds}</span>
        <small>Seconds</small>
      </div>
    </div>
  );
};
